<template>
  <div>
    <Header @goTo="goTo" />
    <div
      :style="{
        width: '100%',
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${mainImage.link}')`,
        backgroundPosition: '50%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'lightgray',
      }"
      id="main"
    >
      <div class="main-component">
        <v-main>
          <v-container>
            <h1 class="site-title">Vivamus GmbH</h1>
            <p class="site-subtitle">Treuhand & Beratung</p>
            <p class="site-subtext">
              Professionell. Persönlich. Zukunftsorientiert.
            </p>
            <p class="welcome-text">Willkommen bei Vivamus GmbH</p>
            <v-row no-gutters justify="center">
              <p style="max-width: 800px" class="site-text">
                Als Ihr verlässlicher Partner unterstützen wir seit 2020 KMU,
                Selbständige und Immobilienverwaltungen in der Schweiz mit
                umfassenden Treuhand- und Beratungsleistungen. Mit Herz,
                Know-how und innovativen Lösungen begleiten wir Sie in den
                Bereichen Buchhaltung, Steuerberatung, Unternehmensgründung und
                vielem mehr.
              </p>
            </v-row>
            <v-row
              no-gutters
              justify="center"
              :style="
                $vuetify.breakpoint.smAndDown
                  ? 'margin-top: 16px'
                  : 'margin-top: 48px'
              "
            >
              <v-btn
                color="#C09559"
                height="48px"
                :width="$vuetify.breakpoint.smAndDown ? '100%' : 'max-content'"
                @click="goTo('#contact')"
                >Jetzt Kontakt aufnehmen</v-btn
              >
              <v-btn
                :width="$vuetify.breakpoint.smAndDown ? '100%' : 'max-content'"
                color="#F8F6F2"
                height="48px"
                style="color: #c09559"
                :style="
                  $vuetify.breakpoint.smAndDown
                    ? 'margin-top: 16px'
                    : 'margin-left: 16px'
                "
                @click="goTo('#contact')"
              >
                Kostenloses Erstgespräch buchen</v-btn
              >
            </v-row>
            <v-row
              no-gutters
              justify="center"
              :style="
                $vuetify.breakpoint.smAndDown
                  ? 'margin-top: 38px'
                  : 'margin-top: 74px'
              "
            >
              <img
                src="@/assets/img/iconsSvg/scrollToDownIcon.svg"
                width="32px"
                height="32px"
                alt="to down"
                style="cursor: pointer"
                @click="goTo('#about_us')"
              />
            </v-row>
          </v-container>
        </v-main>
      </div>
    </div>
    <about-us id="about_us" />
    <our-service id="services" />
    <technologie id="tools" />
    <reviews id="reviews" />
    <contact id="contact" />
  </div>
</template>

<script>
import bannerService from "../../requests/Admin/bannerService";
import Header from "../Header.vue";
import aboutUs from "./aboutUs.vue";
import Contact from "./Contact.vue";
import OurService from "./ourService.vue";
import Reviews from "./reviews/Reviews.vue";
import Technologie from "./Technologie.vue";
export default {
  components: { aboutUs, OurService, Technologie, Contact, Reviews, Header },
  data: () => ({
    mainImage: {},
  }),
  mounted() {
    this.getMainBanner();
  },
  methods: {
    async getMainBanner() {
      await bannerService.getBanners().then((response) => {
        console.log(response, "response");
        this.mainImage = response.find(
          (banner) => banner.name === "main_banner"
        );
      });
    },
    goTo(id) {
      this.$vuetify.goTo(id, {
        duration: 500,
        easing: "easeInOutCubic",
      });
    },
  },
};
</script>

<style scoped>
.main-component {
  width: 100%;
  height: 900px;
  background-size: cover;
  background-position: center;
  padding-top: 70px;
  background: linear-gradient(
    180deg,
    rgba(15, 61, 38, 0.2) -27.89%,
    rgba(15, 61, 38, 0.4) 72.11%
  );
  text-align: center;
  font-style: normal;
  color: rgba(255, 255, 255, 0.9);
}
.site-title {
  color: #c09559;
  text-align: center;
  font-family: "Playfair Display";
  font-size: 72px;
  font-weight: 600;
  line-height: 72px;
  margin-top: 105px;
}
.site-subtitle {
  font-size: 30px;
  font-weight: 600;
  line-height: 36px;
  margin: 20px 0px;
}
.site-subtext {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
}
.welcome-text {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin: 48px 0px 28px 0px;
}
.site-text {
  font-size: 18px;
  font-weight: 400;
  line-height: 29.25px;
}
.v-btn {
  color: #f8f6f2;
  padding: 14px 33px;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-transform: none;
  border-radius: 6px !important;
}
@media (width <= 900px) {
  .site-title {
    font-size: 48px;
    line-height: 60px;
    margin-top: 48px;
  }
  .site-subtitle {
    font-size: 24px;
    line-height: 36px;
    margin: 18px 0px;
  }
  .site-subtext {
    font-size: 20px;
    line-height: 32px;
  }
  .welcome-text {
    font-size: 20px;
    line-height: 32px;
    margin: 34px 0px 12px 0px;
  }
  .site-text {
    font-size: 18px;
    line-height: 30px;
  }
}
</style>
<style>
.section-name {
  color: #163626;
  text-align: center;
  font-family: "Playfair Display";
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
}
</style>